/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchFilterEnum } from './SearchFilterEnum';
import {
    SearchFilterEnumFromJSON,
    SearchFilterEnumFromJSONTyped,
    SearchFilterEnumToJSON,
    SearchFilterEnumToJSONTyped,
} from './SearchFilterEnum';

/**
 * Command object for checking data existence
 * @export
 * @interface IsDataExistingCommandDto
 */
export interface IsDataExistingCommandDto {
    /**
     * The search string to look for in the data
     * @type {string}
     * @memberof IsDataExistingCommandDto
     */
    searchString: string;
    /**
     * 
     * @type {SearchFilterEnum}
     * @memberof IsDataExistingCommandDto
     */
    searchFilter: SearchFilterEnum;
}



/**
 * Check if a given object implements the IsDataExistingCommandDto interface.
 */
export function instanceOfIsDataExistingCommandDto(value: object): value is IsDataExistingCommandDto {
    if (!('searchString' in value) || value['searchString'] === undefined) return false;
    if (!('searchFilter' in value) || value['searchFilter'] === undefined) return false;
    return true;
}

export function IsDataExistingCommandDtoFromJSON(json: any): IsDataExistingCommandDto {
    return IsDataExistingCommandDtoFromJSONTyped(json, false);
}

export function IsDataExistingCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsDataExistingCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'],
        'searchFilter': SearchFilterEnumFromJSON(json['searchFilter']),
    };
}

export function IsDataExistingCommandDtoToJSON(json: any): IsDataExistingCommandDto {
    return IsDataExistingCommandDtoToJSONTyped(json, false);
}

export function IsDataExistingCommandDtoToJSONTyped(value?: IsDataExistingCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'searchFilter': SearchFilterEnumToJSON(value['searchFilter']),
    };
}

